<module-container>
  <div class="title-container">
    <h2>Global Store Purchase PLU</h2>
  </div>
  <abcis-table [configuration]="tableConfig"></abcis-table>
</module-container>
